import { Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { SecondaryButton } from '../../../../Core/FormInput';
import { MandatoryField, SimpleField } from '../../../../Core/FormInput/inputfields';
import { getDriverRateByID, postDriverRates } from '../../../../Core/Service/wipSales-Services/driverRateSales-service';
import { use } from 'react';
import AppContext from '../../../../App/AppContext';

const AddDriverRate = (props) => {
    const [form, setForm] = useState({
        driverRateID: null,
        driverRateBodyType: '',
        driverRateMinPrice: null,
        driverRateMinDistance: null,
        driverRatePencePerMile: null,
        driverRateDefaultSelected: false
    });

    const { showToast } = useContext(AppContext);

    const { rowID, row, onClose } = props;

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const pullDetails = async (ID) => {
        try {
            let res = await getDriverRateByID(ID);
            if (res.success) {
                let data = res.data.list[0];
                setForm({
                    driverRateBodyType: data.driverRateBodyType,
                    driverRateDefaultSelected: data.driverRateDefaultSelected,
                    driverRateID: data.driverRateID,
                    driverRateMinDistance: data.driverRateMinDistance,
                    driverRateMinPrice: data.driverRateMinPrice,
                    driverRatePencePerMile: data.driverRatePencePerMile
                });
                console.log('Driver Rate Details:', res);
            }
        } catch (err) {
            console.error('Error fetching location details:', err);
        }
    };

    useEffect(() => {
        if (rowID) pullDetails(rowID);
    }, [rowID]);

    const validate = () => {
        let err = {};
        if (!form.driverRateBodyType.trim()) err.driverRateBodyType = 'Body Type is required';
        else if (form.driverRateBodyType.length > 50) err.driverRateBodyType = 'Max length is 50 characters';
        // else if (!form.driverRateMinPrice) err.driverRateMinPrice = 'Min Price is required';
        else if (Number(form.driverRateMinPrice) < 0) err.driverRateMinPrice = 'Value must be positive';
        // else if (!form.driverRateMinDistance) err.driverRateMinDistance = 'Min Distance is required';
        else if (Number(form.driverRateMinDistance) < 0) err.driverRateMinDistance = 'Value must be positive';
        // else if (!form.driverRatePencePerMile) err.driverRatePencePerMile = 'Pence Per Mile is required';
        else if (Number(form.driverRatePencePerMile) < 0) err.driverRatePencePerMile = 'Value must be positive';
        setErrors(err);
        return Object.keys(err).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        const payload = {
            ...form,
            driverRateMinPrice: Number(form.driverRateMinPrice),
            driverRateMinDistance: Number(form.driverRateMinDistance),
            driverRatePencePerMile: Number(form.driverRatePencePerMile)
        };

        let res = await postDriverRates(payload);
        if (res) {
            if (res.success) {
                showToast('Driver Rate saved successfully', 'success');
                onClose(true);
            }
            console.log(res, 'Driver Rate added successfully');
        }
        console.log('Submitted:', payload);
    };

    return (
        <div>
            <form onSubmit={handleSubmit} noValidate>
                <Grid container spacing={1}>
                    {/* Body Type */}
                    <Grid item xs={12}>
                        <MandatoryField
                            name="driverRateBodyType"
                            inputLabel="Body Type"
                            variant="outlined"
                            fullWidth
                            value={form.driverRateBodyType}
                            onChange={handleChange}
                            inputProps={{ maxLength: 50 }}
                            error={!!errors.driverRateBodyType}
                            helperText={errors.driverRateBodyType}
                        />
                    </Grid>
                    {/* Min Price */}
                    <Grid item xs={12} sm={6}>
                        <SimpleField
                            name="driverRateMinPrice"
                            inputLabel="Min Price"
                            variant="outlined"
                            fullWidth
                            value={form.driverRateMinPrice}
                            onChange={handleChange}
                            error={!!errors.driverRateMinPrice}
                            helperText={errors.driverRateMinPrice}
                            type="number"
                            inputProps={{ step: '0.01' }}
                        />
                    </Grid>
                    {/* Min Distance */}
                    <Grid item xs={12} sm={6}>
                        <SimpleField
                            name="driverRateMinDistance"
                            inputLabel="Min Distance"
                            variant="outlined"
                            fullWidth
                            value={form.driverRateMinDistance}
                            onChange={handleChange}
                            error={!!errors.driverRateMinDistance}
                            helperText={errors.driverRateMinDistance}
                            type="number"
                            inputProps={{ step: '0.01' }}
                        />
                    </Grid>
                    {/* Pence Per Mile */}
                    <Grid item xs={12} sm={6}>
                        <SimpleField
                            name="driverRatePencePerMile"
                            inputLabel="Pence Per Mile"
                            variant="outlined"
                            fullWidth
                            value={form.driverRatePencePerMile}
                            onChange={handleChange}
                            error={!!errors.driverRatePencePerMile}
                            helperText={errors.driverRatePencePerMile}
                            type="number"
                            inputProps={{ step: '0.01' }}
                        />
                    </Grid>
                    {/* Default Selected */}
                    <Grid item xs={6}>
                        <FormControlLabel
                            style={{ marginTop: 20 }}
                            control={
                                <Checkbox checked={form.driverRateDefaultSelected} onChange={handleChange} name="driverRateDefaultSelected" color="primary" />
                            }
                            label="Default Selected"
                        />
                    </Grid>
                    {/* Submit */}
                    <Grid item xs={12}>
                        <SecondaryButton variant="contained" color="primary" fullWidth type="submit">
                            Save
                        </SecondaryButton>
                    </Grid>
                </Grid>
            </form>
        </div>
    );
};
export default AddDriverRate;
